// extracted by mini-css-extract-plugin
export default {"PageSupport":"PageSupport_PageSupport__IQIVu","PartieGauche":"PageSupport_PartieGauche__PzrLe","PartieDroite":"PageSupport_PartieDroite__DG990"};